export default __webpack_public_path__ + "static/media/2.3e4a7f18.jpg";